import { Update } from '@ngrx/entity'
import { createAction, props } from '@ngrx/store'
import { TotalRaisedEntity } from './total-raised.models'

export const loadTotalRaised = createAction('[TotalRaised/API] Load TotalRaised')

export const loadTotalRaisedSuccess = createAction(
  '[TotalRaised/API] Load TotalRaised Success',
  props<{ totalRaised: TotalRaisedEntity }>(),
)

export const loadTotalRaisedFailure = createAction(
  '[TotalRaised/API] Load TotalRaised Failure',
  props<{ error: string }>(),
)

export const updateTotalRaised = createAction(
  '[TotalRaised/API] Update TotalRaised Success',
  props<{ update: Update<TotalRaisedEntity> }>(),
)
